
export const gradientText = {
    from: {
        default: 'from-aux1-500 dark:from-aux1-200',
    },
    to: {
        default: 'to-primary-500 dark:to-primary-200'
    }
}